import { Result } from 'entities/result'
import { ResultV2ViewModel } from './result_v2_view_model'
import { BreastResultV2ViewModel } from './breast_result_v2_view_model'
import { OvaryResultV2ViewModel } from './ovary_result_v2_view_model'
import { LungResultV2ViewModel } from './lung_result_v2_view_model'
import { StomachResultV2ViewModel } from './stomach_result_v2_view_model'
import { ColorectalResultV2ViewModel } from './colorectal_result_v2_view_model'
import { EsophagusResultV2ViewModel } from './esophagus_result_v2_view_model'
import { PancreasResultV2ViewModel } from './pancreas_result_v2_view_model'
import { Sample } from 'entities/sample'

export class ResultV2ViewModelFactory {
    public static create = (result: Result, sample: Sample): ResultV2ViewModel => {
        if (!result.productItem?.nameEn) {
            throw new Error('Require product item')
        }
        if (result.productItem.nameEn === 'ovary') {
            return new OvaryResultV2ViewModel(result, sample)
        } else if (result.productItem.nameEn === 'breast') {
            return new BreastResultV2ViewModel(result, sample)
        } else if (result.productItem.nameEn === 'lung') {
            return new LungResultV2ViewModel(result, sample)
        } else if (result.productItem.nameEn === 'stomach') {
            return new StomachResultV2ViewModel(result, sample)
        } else if (result.productItem.nameEn === 'colorectal') {
            return new ColorectalResultV2ViewModel(result, sample)
        } else if (result.productItem.nameEn === 'esophagus') {
            return new EsophagusResultV2ViewModel(result, sample)
        } else if (result.productItem.nameEn === 'pancreas') {
            return new PancreasResultV2ViewModel(result, sample)
        } else {
            throw new Error('Invalid cancer type.')
        }
    }
}
